import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function Seo({
  pageKey, // ej: "bancos"
  pathByLang, // { es: "/bancos", en: "/banks" }
  site = "https://atmnetss.com",
  image, // opcional: og:image absoluto
}) {
  const { i18n, t } = useTranslation();
  const { lang: langFromUrl } = useParams();
  const lang = langFromUrl === "es" ? "es" : "en";
  const rawTitle = t(`seo.${pageKey}.title`, { defaultValue: "" });
  const title = rawTitle?.trim() || "ATM Net Systems";

  const description = t(`seo.${pageKey}.description`);
  const keywords = t(`seo.${pageKey}.keywords`);

  const urlEs = site + pathByLang.es;
  const urlEn = site + pathByLang.en;
  const canonical = lang === "es" ? urlEs : urlEn;

  return (
    <Helmet>
      {/* idioma del documento */}
      <html lang={lang} />

      {/* title + description */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* canonical de la versión actual */}
      <link rel="canonical" href={canonical} />

      {/* hreflang alternates */}
      <link rel="alternate" hrefLang="es" href={urlEs} />
      <link rel="alternate" hrefLang="en" href={urlEn} />
      <link rel="alternate" hrefLang="x-default" href={urlEn} />

      {/* Open Graph / Twitter */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={lang === "es" ? "es_ES" : "en_US"} />
      <meta
        property="og:locale:alternate"
        content={lang === "es" ? "en_US" : "es_ES"}
      />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}
